import { Component } from '@angular/core';
import { Observable } from 'rxjs';
import { UserService } from './core/services/user.service';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss'],
  standalone: false
})
export class AppComponent {
  public title = 'nextgen-cms';
  public isLoading$: Observable<boolean>;

  constructor(private readonly userService: UserService) {
    this.isLoading$ = this.userService.isLoading$;
  }
}
